import { ABServiceClient } from '@zocdoc/ab';

import { ACTION_TYPES } from '../constants';
import { FULLSTORY_SCRIPT } from './constants';
import { getABParameters } from '../config/ab/selector';
import { VARIANT_ON, FULL_STORY } from '../config/ab/experiments';

const AB_HOST = process.env.AWS_API_HOST || '';

export const abClient = new ABServiceClient({
    fetch,
    basePath: AB_HOST,
});

/**
 *  Function to load fullstory depending on AB flag
 */
export const loadFullStory = () => {
    const fullstoryScript = document.createElement('script');
    fullstoryScript.defer = true;
    fullstoryScript.innerHTML = FULLSTORY_SCRIPT;
    document.head.appendChild(fullstoryScript);
};

const fullstoryMiddleware = store => next => action => {
    if (action.type === ACTION_TYPES.PAGE_LOAD) {
        const abParameters = getABParameters(store.getState());

        if (abParameters[FULL_STORY.experimentId] === VARIANT_ON) {
            loadFullStory();
        }
    }

    return next(action);
};

export {
    fullstoryMiddleware,
    fullstoryMiddleware as default,
};
